import { useNavigate, useParams } from 'react-router-dom'
import useForm from '@/hooks/useForm'
import { UpdateDoctor } from '@/api/endpoints/Doctors'
import { useUpdate } from '@/api/hooks'
import { uploadFile } from '@/api/endpoints/file'
import { useState } from 'react'

const useEditDoctor = () => {
    const navigate = useNavigate()
    const { formHandler, onSubmit } = useForm()
    const { handleFormValues } = formHandler
    const { onUpdate, isLoading: isSubmitting } = useUpdate(UpdateDoctor)
    const [isUploadingfile, setIsUploadingfile] = useState(false)
    const { doctorId } = useParams()

    const handleProfileImageChange = (file) => {
        handleFormValues('image', { value: file, isRequired: false, isError: false })
    }

    //   const handleDocumentsChange = (files) => {
    //       const fileArray = Array.isArray(files) ? files : Array.from(files)
    //       handleFormValues('documents', { value: fileArray, isRequired: false, isError: false })
    //   }
    //
    //   const removeDocument = (index) => {
    //       const updatedDocuments = documents.filter((_, i) => i !== index)
    //       handleFormValues('documents', { value: updatedDocuments, isRequired: false, isError: false })
    //   }

    const handleSubmit = () => {

        onSubmit((d) => {
            const formData = new FormData()

            if (formHandler?.formValues?.image?.value)
                formHandler?.formValues?.image?.value.forEach(file => {
                    formData.append('doctorLogo', file)
                })

            setIsUploadingfile(true)
            uploadFile(formData).then(response => {
                let DataObject = {
                    name: formHandler?.formValues?.doctorName?.value,
                    nameEn: formHandler?.formValues?.doctorNameEn?.value,
                    email: formHandler?.formValues?.email?.value,
                    phoneNumber: formHandler?.formValues?.phoneNumber?.value,
                    bio: formHandler?.formValues?.bio?.value,
                    bioEn: formHandler?.formValues?.bioEn?.value,
                    birthDate: formHandler?.formValues?.birthDate?.value,
                    providerId: formHandler?.formValues?.providerId?.value,
                    specialtyId: formHandler?.formValues?.specialty?.value?.value,
                    majorSpecialtyId: formHandler?.formValues?.department?.value?.value,
                    attachmentIdsToAdd: response.data,
                    attachmentIdsToRemove:  formHandler?.formValues?.removedId?.value ?[formHandler?.formValues?.removedId?.value]:[],
                }
                onUpdate(doctorId, DataObject ,()=>{
                    navigate("/panel/provider/doctors")
                })
            }).finally(() => {
                setIsUploadingfile(false)
            })
        })
    }

    const navToDoctorReport = () =>
        navigate('/panel/provider/doctors')


    const resetForm = () => {
        setProfileImage(null)
        setDocuments([])
    }

    return {
        isLoading: isSubmitting || isUploadingfile,

        profileImage: formHandler?.formValues?.image?.value || [],
        handleProfileImageChange,

        formHandler,

        //   documents: formHandler?.formValues?.documents?.value || [],
        //   handleDocumentsChange,
        //   removeDocument,

        handleSubmit,
        navToDoctorReport,
        resetForm,

        navigate
    }
}

export default useEditDoctor

